(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rfq-sticky-bar"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rfq-scroll]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target =
        document.querySelector('.storeify-btn-custom') || document.querySelector('.product__info-container');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
